<template>
  <div class="listings-card">
    <div class="card">
      <div class="card-content">
        <div class="content has-text-centered">
          <slot name="logo" />
        </div>
      </div>
      <footer class="card-footer">
        <p class="card-footer-item">
          <span>
            <small>Last updated:</small><br>
            <slot name="last-updated" />
          </span>
        </p>
        <a
          href="#"
          class="card-footer-item"
        >
          <slot name="view-listing" />
        </a>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ListingsCard'
}
</script>
<style lang="scss" scoped>
.listings-card {
  margin-top: 10px;
}
</style>
